import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { ComponentsModule } from '../../components/components.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HomeComponent],
    imports: [CommonModule, ComponentsModule, TranslateModule],
    exports: [HomeComponent],
})
export class HomeModule {}
